import { useAppSelector } from "@/app_redux/hooks/root_hook";
import { SlideoverReducerStateIdKeys } from "@/app_redux/reducers/reducer_interface";

export const useSlideoverState = (slideoverId: SlideoverReducerStateIdKeys) => {
  const slideoverStates = useAppSelector((state) => state.slideover_states);
  return slideoverStates[slideoverId] ?? {};
};
